import { lazy } from 'react';

const DashboardPage = lazy(() => import('./DashboardPage'));

export { DashboardPage };
